import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal, godownCreate, godownList, godownSingleData, godownUpdate, openModal } from '../../../../../redux/actions/action-creator';
import { toast } from 'react-toastify';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import Form from '../../../../../components/Form/Form';

function GoDownView({ data_to_view, title, closeModal_sec }) {

  const dispatch = useDispatch();
  const [load, setLoad] = useState(false)
  const { userData = null } = useSelector(state => state.auth);

  const initialState = {
    name: '',
    alias_name: '',
    under: 'Primary',
    under_id: 'Primary',
    company_id: userData?.company_id
  }
  const [data, setData] = useState(initialState);
  useEffect(() => {
    setLoad(true)
    const formData = new FormData();
    formData.append('id', data_to_view?.id);
    formData.append('company_id', userData?.company_id);
    dispatch(godownSingleData(formData)).then((response) => {
      if (response?.status) {
        console.log("this is godowon id :", response)
        setData({
          name: response.data?.name,
          alias_name: response.data?.alias_name,
          under_id: response.data?.under ? response?.data?.under : 'Primary',
          under: response.data?.under,
          company_id: userData?.company_id,
          id: data_to_view?.id
        })
        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      console.log(error)
      toast.error(error?.Responsemessage || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])

  return (
    <Form
      title='GoDown View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Alias
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.alias_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Under
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.under}
        </div>
      </div>
    </Form>
  )
}

export default GoDownView

